var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M5 1h2M4 2h1m2 0h1M3 3h1m4 0h1M2 4h1m6 0h1M1 5h1m8 0h1M0 6h1m10 0h1M1 7h1m8 0h1M1 8h1m8 0h1M1 9h1m8 0h1M1 10h1m8 0h1M1 11h3m4 0h3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c19b3b",
    d: "M5 2h1M4 3h1M4 4h1m0 1h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#997d40",
    d: "M6 2h1m0 1h1M7 4h1M6 5h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc83d",
    d: "M5 3h1M5 4h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d7aa41",
    d: "M6 3h1M6 4h1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5d553f",
    d: "M3 4h1M2 5h3M1 6h5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#353844",
    d: "M8 4h1M7 5h3M6 6h5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#905009",
    d: "M2 7h4M2 8h3M2 9h2m-2 1h2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#68320e",
    d: "M6 7h4M7 8h3M8 9h2m-2 1h2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#191919",
    d: "M5 8h2M4 9h4m-4 1h4m-4 1h4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMine);
export default __webpack_public_path__ + "static/media/mine.cd4f54f0bbb9400a7a20c01d8e0418ef.svg";
export { ForwardRef as ReactComponent };